module.exports = __webpack_public_path__ + "img/gcr-affichette-de-chantier.86620014.jpg";